<div class="wrapper-config-menu menu" *ngIf="config && class">
    <!-- Hiển thị tiêu đề mở rộng -->
    <div class="editor-header menu-header" *ngIf="isViewAll">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <ng-container *ngIf="!isViewAll">
      <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
        [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
      </app-position-out-config>
  
      <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing"
        [width]="config['type'] == 'horizontal'? class['menu']['width'] : class['mobilemenu']['width']"
        [height]="config['type'] == 'horizontal'? class['menu']['height'] : class['mobilemenu']['height']"
        (changeWidthHeight)="changeWidthHeight($event)">
      </app-width-height-config>
      <div>
        <ul nz-menu nzMode="inline">
          <!-- HIỂN THỊ -->
          <li nz-submenu nzTitle="{{'chinh_sua_noi_dung' | translate}}" [(nzOpen)]="openMap.menu0" (nzOpenChange)="openHandler('menu0')">
            <button class="mt-3" nz-button nzType="primary" (click)="openModalEdit()">{{'chinh_sua_noi_dung' | translate}}</button>
          </li>
        </ul>
      </div>

      <!-- Kiểu thị menu ngang -->
      <ul *ngIf="config['type'] == 'horizontal' && class['menu']?.width && class['menu__item']" nz-menu nzMode="inline">
        <!-- KIỂU MENU -->
        <li nz-submenu nzTitle="{{'kieu_menu' | translate}}" [(nzOpen)]="openMap.menu13" (nzOpenChange)="openHandler('menu13')">
          <nz-checkbox-group [(ngModel)]="listGroupLink"
            (ngModelChange)="handleSelectGroups(listGroupLink)"></nz-checkbox-group>
        </li>
        <!-- Chọn kiểu hiển thị -->
        <li nz-submenu nzTitle="{{'chon_kieu_hien_thi' | translate}}" [(nzOpen)]="openMap.menu17"
        (nzOpenChange)="openHandler('menu17')">
          <nz-select [(ngModel)]="config['type']" nzPlaceHolder="{{'chon_kieu_hien_thi' | translate}}"
            (ngModelChange)="handleChangeTypeMenu($event)">
            <nz-option nzValue="horizontal" nzLabel="{{'doc' | translate}}"></nz-option>
            <nz-option nzValue="vertical" nzLabel="{{'dien_thoai' | translate}}"></nz-option>
          </nz-select>
          <!-- Hướng xuất hiện -->
          <div >
            <p>{{'huong_xuat_hien' | translate}}</p>
            <div class="config-position">
              <button 
                nz-button
                class="config-position__btn" 
                [nzType]="config['direction'] == 'left'? 'primary': 'default'" 
                (click)="config['direction'] = 'left'; updateConfig()"
              >
                <span class="config-position__btn--content">{{'trai' | translate}}</span>
              </button>
              <button 
                nz-button
                class="config-position__btn" 
                [nzType]="config['direction'] == 'right'? 'primary': 'default'" 
                (click)="config['direction'] = 'right'; updateConfig()"
              >
                <span class="config-position__btn--content">{{'phai' | translate}}</span>
              </button>
            </div>
          </div>
        </li>
        <!-- CẤU HÌNH MENU -->
        <li nz-submenu nzTitle="{{'cau_hinh_menu' | translate}}">
          <ul>
            <!-- Định dạnh chữ -->
            <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}" [(nzOpen)]="openMap.menu1"
              (nzOpenChange)="openHandler('menu1')">
              <div class="field-format-font menu-field">
                <div class="container-font field-font">
                  <div class="config-font-size">
                    <!-- Font-family -->
                    <div class="field-row-font" style="width: 65%">
                      <mat-form-field style="width: 100%">
                        <mat-label>Font</mat-label>
                        <mat-select [(value)]="
                            class['menu__item--content-inner']['font-family']
                          " [(ngModel)]="
                            class['menu__item--content-inner']['font-family']
                          " (ngModelChange)="updateClass()">
                          <mat-option *ngFor="let font of fonts" [value]="font.value">{{ font.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <!-- Kích thước -->
                    <div class="field-row-size" style="width: 35%">
                      <mat-form-field style="width: 100%">
                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                        <input matInput type="number" [ngModel]="
                            class['menu__item--content-inner']['font-size']
                              | vhnumber
                          " (ngModelChange)="
                            class['menu__item--content-inner']['font-size'] =
                              $event + 'px'
                          " (blur)="updateClass()" />
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                  <div class="config-font">
                    <p class="title-font">{{'kieu_chu' | translate}}</p>
                    <div class="field-row">
                      <!-- In đậm -->
                      <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                        (class['menu__item--content-inner']['font-weight'] >= 700 || class['menu__item--content-inner']['font-weight'] == 'bold')
                          ? 'primary'
                          : 'default'
                        " (click)="
                          class['menu__item--content-inner']['font-weight'] =
                            (class['menu__item--content-inner']['font-weight'] >= 700 || class['menu__item--content-inner']['font-weight'] == 'bold')
                              ? 400
                              : 700;
                          updateClass()
                        ">
                        <span style="font-weight: 500">B</span>
                      </button>
                      <!-- In nghiêng -->
                      <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                          class['menu__item--content-inner']['font-style'] ==
                          'italic'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['menu__item--content-inner']['font-style'] =
                            class['menu__item--content-inner']['font-style'] ==
                            'normal'
                              ? 'italic'
                              : 'normal';
                          updateClass()
                        ">
                        <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Gạch dưới -->
                      <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                          class['menu__item--content-inner'][
                            'text-decoration-line'
                          ] == 'underline'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['menu__item--content-inner'][
                            'text-decoration-line'
                          ] =
                            class['menu__item--content-inner'][
                              'text-decoration-line'
                            ] == 'none'
                              ? 'underline'
                              : 'none';
                          updateClass()
                        ">
                        <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- In hoa -->
                      <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                          class['menu__item--content-inner']['text-transform'] ==
                          'uppercase'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['menu__item--content-inner']['text-transform'] =
                            class['menu__item--content-inner'][
                              'text-transform'
                            ] == 'none'
                              ? 'uppercase'
                              : 'none';
                          updateClass()
                        ">
                        <span>AB</span>
                      </button>
                      <!-- Màu chữ -->
                      <div>
                        <input id="text-color" class="input-color " type="button" [cpPositionRelativeToArrow]="true" [style.background]="
                            class['menu__item--content']['color']
                          " [cpOKButton]="true" [(colorPicker)]="class['menu__item--content']['color']" (colorPickerClose)="updateClass()" />
                      </div>
                    </div>
                  </div>

                  <!-- Độ đậm -->
                  <div class="config-font">
                    <div class="d-flex justify-content-between align-items-center mb-0">
                      <p>{{'do_dam' | translate}}</p>
                      <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                        [(ngModel)]="class['menu__item--content-inner']['font-weight']" (nzBlur)="updateClass()"
                        style="width: 40%;">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                          [(ngModel)]="class['menu__item--content-inner']['font-weight']" (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>

                  <!-- Canh lề -->
                  <div class="config-font">
                    <p class="title-font">{{'canh_le' | translate}}</p>
                    <div class="field-row" style="justify-content: normal;">
                        <button class="font-text-btn" nz-button style="width:35px;flex:none"
                            [nzType]="class['menu__item--content']['justify-content'] == 'flex-start' ? 'primary': 'default'"
                            (click)="class['menu__item--content']['justify-content'] = 'flex-start'; updateObject()">
                            <i nz-icon nzType="align-left" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button style="width:35px;flex:none"
                            [nzType]="class['menu__item--content']['justify-content'] == 'center' ? 'primary': 'default'"
                            (click)="class['menu__item--content']['justify-content'] = 'center'; updateObject()">
                            <i nz-icon nzType="align-center" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button style="width:35px;flex:none"
                            [nzType]="class['menu__item--content']['justify-content'] == 'flex-end' ? 'primary': 'default'"
                            (click)="class['menu__item--content']['justify-content'] = 'flex-end'; updateObject()">

                            <i nz-icon nzType="align-right" nzTheme="outline"></i>
                        </button>
                    </div>
                  </div>
  
                  <!-- giãn cách đều --> 
                  <div class="config-font">
                    <nz-radio-group [(ngModel)]="class['menu__item']['width']" (ngModelChange)="updateClass()">
                      <label nz-radio nzValue="100%">{{'gian_cach_deu' | translate}}</label>
                      <label nz-radio nzValue="fit-content">{{'vua_voi_noi_dung' | translate}}</label>
                    </nz-radio-group>
                  </div>

                  <!-- Khoảng cách chữ -->
                  <app-letter-spacing-config
                    [objectChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [classLetterSpacing]="class['menu__item--content-inner']">
                  </app-letter-spacing-config>

                  <!-- Khoảng đệm -->
                  <div class="config-font">
                    <app-padding-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classPadding]="class['menu__item--content-left']"
                      [paddingConfigs]="[
                        { type: 'left', label: 'thut_le', min: 0, max: 30 },
                        { type: 'top' },
                        { type: 'bottom' }
                      ]">
                    </app-padding-config>
                  </div>

                  <!-- Khoảng cách dòng -->
                  <app-line-height-config
                    [objectChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [classLineHeight]="class['menu__item--content']">
                  </app-line-height-config>
  
                </div>
              </div>
            </li>

            <!-- CANH LỀ DỌC -->
            <li class="pl-2" nz-submenu [nzTitle]="'canh_le_doc' | translate" [(nzOpen)]="openMap.menu19" (nzOpenChange)="openHandler('menu19')">
              <div class="config-font">
                <div class="font">
                  <button class="font-text-btn" nz-button title="flex-start" 
                    [nzType]="class['menu__item--content']['align-items'] == 'flex-start' ? 'primary' : 'default'" 
                    (click)="class['menu__item--content']['align-items'] = 'flex-start'; updateClass()">
                    <i nz-icon nzType="vertical-align-top" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button title="center"
                    [nzType]="class['menu__item--content']['align-items'] == 'center' ? 'primary' : 'default'" 
                    (click)="class['menu__item--content']['align-items'] = 'center'; updateClass()">
                    <i nz-icon nzType="vertical-align-middle" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button title="flex-end"
                    [nzType]="class['menu__item--content']['align-items'] == 'flex-end' ? 'primary' : 'default'" 
                    (click)="class['menu__item--content']['align-items'] = 'flex-end'; updateClass()">
                    <i nz-icon nzType="vertical-align-bottom" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
            </li>

            <!-- Cấu hình viền -->
            <li class="pl-2" nz-submenu nzTitle="{{'vien_va_bo_tron' | translate}}" [(nzOpen)]="openMap.menu2"
              (nzOpenChange)="openHandler('menu2')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['menu__item']"
                [id_object]="objectChoosing._id">
              </app-borders-config>
              <!-- Bo tròn -->
              <div class="my-3">
                <div class="config-name mb-0">
                  <p>{{'bo_tron' | translate}}</p>
                  <nz-input-number [nzMin]="0"  [ngModel]="class['menu__item']['border-radius'] | vhnumber"
                    (ngModelChange)="
                      class['menu__item']['border-radius'] = $event + 'px'
                    " (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0"  [ngModel]="class['menu__item']['border-radius'] | vhnumber"
                  (ngModelChange)="
                    class['menu__item']['border-radius'] = $event + 'px'
                  " (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </li>
            <!-- Cấu hình màu nền -->
            <li class="pl-2" nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu3"
              (nzOpenChange)="openHandler('menu3')">
              <div class="container-color">
                <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                  [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'menu')"
                  nz-tooltip [disabled]="config[fieldConfigGradient[5]].gradient_check"></button>
              </div>
              <div class="color-pick">
                <span class="title w-50">{{'chon_mau' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['menu__item']['background-color']"
                  [style.background]="class['menu__item']['background-color']" (colorPickerClose)="updateClass()"
                  [cpPositionRelativeToArrow]="true" [disabled]="config[fieldConfigGradient[5]].gradient_check" />
              </div>
              <div class="mr-2 mb-4 mt-4 view-more" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 7px;
              ">
                <p class="discover_text" (click)="openViewAll(styles_field[4])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{'mau_gradient' | translate}} &#8594;
                </p>
              </div>
              <!-- Mở popup so sánh màu tương phản -->
              <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
              nz-row (click)="openColorContrast('menu')" nz-tooltip
              [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
              style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;"
              [disabled]="config[fieldConfigGradient[5]].gradient_check">
                {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
              </button>
            </li>
            <!-- Cấu hình đổ bóng -->
            <li class="pl-2" nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4"
              (nzOpenChange)="openHandler('menu4')">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['menu__item']"
                [shadowConfig]="config['menu_box-shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>
            <!-- Cấu hình khoảng cách giữa các menu-item -->
            <li class="pl-2" nz-submenu nzTitle="{{'khoang_cach' | translate}}" [(nzOpen)]="openMap.menu5"
              (nzOpenChange)="openHandler('menu5')">
              <div class="mb-3">
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_cac_menu_cha' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class['menu']['gap'] | vhnumber"
                    (ngModelChange)="class['menu']['gap'] = $event + 'px'" (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class['menu']['gap'] | vhnumber"
                  (ngModelChange)="class['menu']['gap'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </li>
            <!-- Biểu tượng -->
            <li class="pl-2" nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6"
              (nzOpenChange)="openHandler('menu6')">
              <div class="field-format-font">
                <!-- Vị trí của icon trước và chữ -->
                <div *ngIf="
                 class['menu__item--content']['justify-content'] ==
                   'space-between' || !config['icon_menu']['show_icon_sub']
               " class="mt-3">
                  <p style="line-height: 1.5">{{'vi_tri_cua_icon_truoc_va_chu' | translate}}</p>
                  <nz-radio-group [(ngModel)]="
                   class['menu__item--content']['justify-content']
                 " (ngModelChange)="updateClass()">
                    <label nz-radio nzValue="center">{{'canh_giua' | translate}}</label>
                    <label nz-radio nzValue="flex-start">{{'canh_trai' | translate}}</label>
                    <label nz-radio nzValue="flex-end">{{'canh_phai' | translate}}</label>
                  </nz-radio-group>
                </div>
                <div class="mt-4">
                  <p>{{'vi_tri_icon_tu_chon' | translate}}</p>
                  <nz-radio-group [(ngModel)]="selectedValuePosition"  (ngModelChange)="
                   handleSetPositionIcon($event)
                 ">
                    <label nz-radio nzValue="before">{{'truoc' | translate}}</label>
                    <label nz-radio nzValue="after">{{'sau' | translate}}</label>
                  </nz-radio-group>
                </div>
                <!-- Icon tự chọn -->
                <p style="font-weight: 500; margin-top: 30px; line-height: 1.5">
                  {{'icon_tu_chon' | translate}}
                </p>
                <!-- Màu icon (icon tự chọn) -->
                <div class="config-name">
                  <p>{{'mau_icon_tu_chon' | translate}}</p>
                  <div style="width: 40%; max-width: 40%">
                    <input class="input-color w-100" [cpPositionRelativeToArrow]="true"
                      [style.background]="class['menu__item--icon-before']['color']"
                      [cpOKButton]="true" [(colorPicker)]="class['menu__item--icon-before']['color']" (colorPickerClose)="updateClass()" type="button" />
                  </div>
                </div>
                <!-- Kích thước (icon tự chọn) -->
                <div class="mb-2">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="
                     class['menu__item--icon-before']['font-size'] | vhnumber
                   " (ngModelChange)="
                     class['menu__item--icon-before']['font-size'] =
                       $event + 'px'
                   " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="
                   class['menu__item--icon-before']['font-size'] | vhnumber
                 " (ngModelChange)="
                   class['menu__item--icon-before']['font-size'] =
                     $event + 'px'
                 " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- {{'khoang_cach_ben_trai' | translate}} (icon tự chọn) -->
                <div class="mb-2">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach_ben_trai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="
                     class['menu__item--icon-before']['margin-left'] | vhnumber
                   " (ngModelChange)="
                     class['menu__item--icon-before']['margin-left'] =
                       $event + 'px'
                   " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="
                   class['menu__item--icon-before']['margin-left'] | vhnumber
                 " (ngModelChange)="
                   class['menu__item--icon-before']['margin-left'] =
                     $event + 'px'
                 " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- {{'khoang_cach_ben_phai' | translate}} (icon tự chọn) -->
                <div class="mb-2">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach_ben_phai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="
                     class['menu__item--icon-before']['margin-right']
                       | vhnumber
                   " (ngModelChange)="
                     class['menu__item--icon-before']['margin-right'] =
                       $event + 'px'
                   " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="
                   class['menu__item--icon-before']['margin-right'] | vhnumber
                 " (ngModelChange)="
                   class['menu__item--icon-before']['margin-right'] =
                     $event + 'px'
                 " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Icon sau -->
                <p style="font-weight: 500; margin-top: 30px; line-height: 1.5">
                  {{'icon_mac_dinh' | translate}}
                </p>
                <!-- Hiển thị icon đuôi -->
                <div class="config-name">
                  <p>{{'hien_thi_icon_duoi' | translate}}</p>
                  <nz-switch [(ngModel)]="config['icon_menu']['show_icon_sub']"
                    (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <div *ngIf="config['icon_menu']['show_icon_sub']">
                  <!-- Vị trí -->
                  <div class="mt-4">
                    <p>{{'vi_tri' | translate}}</p>
                    <nz-radio-group [(ngModel)]="
                     class['menu__item--content']['justify-content']
                   " (ngModelChange)="
                     handleSetIconAfterPosition('menu'); updateObject()
                   ">
                      <label nz-radio nzValue="center">{{'canh_giua' | translate}}</label>
                      <label nz-radio nzValue="space-between">{{'canh_phai' | translate}}</label>
                    </nz-radio-group>
                  </div>
                  <!-- Font -->
                  <div class="config-name">
                    <p>Font</p>
                    <mat-form-field style="width: 50% !important">
                      <mat-select [(value)]="config['icon_menu']['name_icon']"
                        [(ngModel)]="config['icon_menu']['name_icon']" (ngModelChange)="updateConfig()">
                        <mat-select-trigger>
                          <mat-icon class="mr-2">{{
                            config["icon_menu"]["name_icon"]
                            }}</mat-icon>
                        </mat-select-trigger>
                        <mat-option *ngFor="let icon of optionsIcon" [value]="icon.icon">
                          <mat-icon class="mr-2">{{ icon.icon }}</mat-icon>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div class="mb-2">
                    <div class="config-name mb-0">
                      <p>{{'kich_thuoc' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="
                       class['menu__item--icon']['font-size'] | vhnumber
                     " (ngModelChange)="
                       class['menu__item--icon']['font-size'] = $event + 'px'
                     " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="
                     class['menu__item--icon']['font-size'] | vhnumber
                   " (ngModelChange)="
                     class['menu__item--icon']['font-size'] = $event + 'px'
                   " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                  <!-- Màu icon (icon mặc định) -->
                  <div class="config-name">
                    <p>{{'mau_icon_mac_dinh' | translate}}</p>
                    <div style="width: 40%; max-width: 40%">
                      <input class="input-color w-100" [cpPositionRelativeToArrow]="true"
                        [style.background]="class['menu__item--icon']['color']"
                        [cpOKButton]="true" [(colorPicker)]="class['menu__item--icon']['color']" (colorPickerClose)="updateClass()" type="button" />
                    </div>
                  </div>
                  <!-- {{'khoang_cach_ben_trai' | translate}} (icon mặc định) -->
                  <div class="mb-2">
                    <div class="config-name mb-0">
                      <p>{{'khoang_cach_ben_trai' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                       class['menu__item--icon']['margin-left'] | vhnumber
                     " (ngModelChange)="
                       class['menu__item--icon']['margin-left'] = $event + 'px'
                     " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                     class['menu__item--icon']['margin-left'] | vhnumber
                   " (ngModelChange)="
                     class['menu__item--icon']['margin-left'] = $event + 'px'
                   " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                  <!-- {{'khoang_cach_ben_phai' | translate}} (icon sau) -->
                  <div class="mb-2">
                    <div class="config-name mb-0">
                      <p>{{'khoang_cach_ben_phai' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                       class['menu__item--icon']['margin-right'] | vhnumber
                     " (ngModelChange)="
                       class['menu__item--icon']['margin-right'] =
                         $event + 'px'
                     " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                     class['menu__item--icon']['margin-right'] | vhnumber
                   " (ngModelChange)="
                     class['menu__item--icon']['margin-right'] = $event + 'px'
                   " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                  <!-- Vị trí ngang -->
                  <!-- <div class="mb-2">
                                 <div class="config-name">
                                     <p>Vị trí ngang</p>
                                     <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                                         [ngModel]="class['menu__item--icon']['width'] | vhnumber"
                                         (ngModelChange)="class['menu__item--icon']['width'] = $event + '%';"
                                         (nzBlur)="updateObject()">
                                     </nz-input-number>
                                 </div>
                                 <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                                     [ngModel]="class['menu__item--icon']['width'] | vhnumber"
                                     (ngModelChange)="class['menu__item--icon']['width'] = $event + '%';"
                                     (nzOnAfterChange)="updateObject()">
                                 </nz-slider>
                             </div> -->
                  <!-- Vị trí dọc (icon sau) -->
                  <div class="mb-2">
                    <div class="config-name">
                      <p>{{'vi_tri_doc' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                        [ngModel]="class['menu__item--icon']['top'] | vhnumber" (ngModelChange)="
                       class['menu__item--icon']['top'] = $event + '%'
                     " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['menu__item--icon']['top'] | vhnumber" (ngModelChange)="
                     class['menu__item--icon']['top'] = $event + '%'
                   " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                </div>
              </div>
            </li>
            
          </ul>
        </li>
        <!-- CẤU HÌNH MENU CON -->
        <li nz-submenu nzTitle="{{'cau_hinh_menu_con' | translate}}" (mouseover)="showSubMenu()" (mouseleave)="hideSubMenu()"> 
          <ul>
            <!-- Cấu hình Font chữ -->
            <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}" [(nzOpen)]="openMap.menu7" 
              (nzOpenChange)="openHandler('menu7')">
              <div class="field-format-font">
                <div class="container-font">
                  <div class="config-font-size">
                    <!-- Font-family -->
                    <div class="field-row-font" style="width: 65%">
                      <mat-form-field style="width: 100%">
                        <mat-label>Font</mat-label>
                        <mat-select [(value)]="
                            class['submenu__item--content-inner']['font-family']
                          " [(ngModel)]="
                            class['submenu__item--content-inner']['font-family']
                          " (ngModelChange)="updateClass()">
                          <mat-option *ngFor="let font of fonts" [value]="font.value">{{ font.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <!-- Kích thước -->
                    <div class="field-row-size" style="width: 35%">
                      <mat-form-field style="width: 100%">
                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                        <input matInput type="number" [ngModel]="
                            class['submenu__item--content-inner']['font-size']
                              | vhnumber
                          " (ngModelChange)="
                            class['submenu__item--content-inner']['font-size'] =
                              $event + 'px'
                          " (blur)="updateClass()" />
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                  <div class="config-font">
                    <p class="title-font">{{'kieu_chu' | translate}}</p>
                    <div class="field-row">
                      <!-- In đậm -->
                      <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                        (class['submenu__item--content-inner']['font-weight'] >= 700 || class['submenu__item--content-inner']['font-weight'] == 'bold')
                          ? 'primary'
                          : 'default'
                        " (click)="
                          class['submenu__item--content-inner']['font-weight'] =
                            (class['submenu__item--content-inner']['font-weight'] >= 700 || class['submenu__item--content-inner']['font-weight'] == 'bold')
                              ? 400
                              : 700;
                          updateClass()
                        ">
                        <span style="font-weight: 500">B</span>
                      </button>
                      <!-- In nghiêng -->
                      <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                          class['submenu__item--content-inner']['font-style'] ==
                          'italic'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['submenu__item--content-inner']['font-style'] =
                            class['submenu__item--content-inner']['font-style'] ==
                            'normal'
                              ? 'italic'
                              : 'normal';
                          updateClass()
                        ">
                        <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Gạch dưới -->
                      <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button
                        [nzType]="
                          class['submenu__item--content-inner']['text-decoration-line' ] == 'underline'? 'primary': 'default'" (click)="
                          class['submenu__item--content-inner'][
                            'text-decoration-line'
                          ] =
                            class['submenu__item--content-inner'][
                              'text-decoration-line'
                            ] == 'none'
                              ? 'underline'
                              : 'none';
                          updateClass()
                        ">
                        <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- In hoa -->
                      <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                          class['submenu__item--content-inner'][
                            'text-transform'
                          ] == 'uppercase'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['submenu__item--content-inner'][
                            'text-transform'
                          ] =
                            class['submenu__item--content-inner'][
                              'text-transform'
                            ] == 'none'
                              ? 'uppercase'
                              : 'none';
                          updateClass()
                        ">
                        <span>AB</span>
                      </button>
                      <!-- Màu chữ -->
                      <div>
                        <input id='text-color' class="input-color " [cpPositionRelativeToArrow]="true" [style.background]="
                            class['submenu__item--content']['color']
                          " [cpOKButton]="true" [(colorPicker)]="
                            class['submenu__item--content']['color']
                          " (colorPickerClose)="updateClass()" type="button"/>
                      </div>
                    </div>
                  </div>
                  <!-- Độ đậm -->
                  <div class="config-font">
                    <div class="d-flex justify-content-between align-items-center mb-0">
                      <p>{{'do_dam' | translate}}</p>
                      <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                        [(ngModel)]="class['submenu__item--content-inner']['font-weight']" (nzBlur)="updateClass()"
                        style="width: 40%;">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                          [(ngModel)]="class['submenu__item--content-inner']['font-weight']" (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>
                  <!-- Canh lề -->
                  <div class="config-font">
                        <p class="title-font">{{'canh_le' | translate}}</p>
                        <div class="field-row" style="justify-content: normal;">
                            <button class="font-text-btn" nz-button style="width:35px;flex:none"
                                [nzType]="class['submenu__item--content-left']['text-align'] == 'left' ? 'primary': 'default'"
                                (click)="class['submenu__item--content-left']['text-align'] = 'left'; updateObject()">
                                <i nz-icon nzType="align-left" nzTheme="outline"></i>
                            </button>
                            <button class="font-text-btn" nz-button style="width:35px;flex:none"
                                [nzType]="class['submenu__item--content-left']['text-align'] == 'center' ? 'primary': 'default'"
                                (click)="class['submenu__item--content-left']['text-align'] = 'center'; updateObject()">
                                <i nz-icon nzType="align-center" nzTheme="outline"></i>
                            </button>
                            <button class="font-text-btn" nz-button style="width:35px;flex:none"
                                [nzType]="class['submenu__item--content-left']['text-align'] == 'right' ? 'primary': 'default'"
                                (click)="class['submenu__item--content-left']['text-align'] = 'right'; updateObject()">
  
                                <i nz-icon nzType="align-right" nzTheme="outline"></i>
                            </button>
                        </div>
                  </div>
                  <!-- Giãn cách chữ -->
                  <div class="config-font">
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['submenu__item--content-inner']">
                    </app-letter-spacing-config>
                  </div>
                  
                  <!-- Thụt lề trái -->
                  <div class="config-font">
                    <app-padding-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classPadding]="class['submenu__item--content-left']"
                      [paddingConfigs]="[
                        { type: 'left', label: 'thut_le_trai' },
                      ]">
                    </app-padding-config>
                  </div>
  
                   <!-- Chiều dài menu con -->
                  <div class="config-font">
                    <div class="config-name mb-0">
                      <p>{{'chieu_dai_menu_con' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                          class['submenu']['width']
                            | vhnumber
                        " (ngModelChange)="
                          class['submenu']['width'] =
                            $event + '%'
                        " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                        class['submenu']['width']
                          | vhnumber
                      " (ngModelChange)="
                        class['submenu']['width'] =
                          $event + '%'
                      " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                </div>
              </div>
            </li>
  
            <li class="pl-2" nz-submenu nzTitle ="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMap.menu14"> 
              <app-borders-config 
                [elementChoosing]="objectChoosing"
                [device]="device" 
                [class]="class" 
                [borderClass]="class['submenu__container']"
                [id_object]="objectChoosing._id"
              >
              </app-borders-config>
              
              <!-- Bo tròn -->
              <div class="my-3">
                <div class="config-name mb-0">
                  <p>{{'bo_tron' | translate}}</p>
                  <nz-input-number [nzMin]="0"  [ngModel]="class['submenu__container']['border-radius'] | vhnumber"
                    (ngModelChange)="
                      class['submenu__container']['border-radius'] = $event + 'px'
                    " (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0"  [ngModel]="class['submenu__container']['border-radius'] | vhnumber"
                  (ngModelChange)="
                    class['submenu__container']['border-radius'] = $event + 'px'
                  " (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </li>
  
            <!-- Cấu hình viền -->
            <li class="pl-2" nz-submenu nzTitle="{{'vien_va_bo_tron' | translate}}" [(nzOpen)]="openMap.menu8" 
              (nzOpenChange)="openHandler('menu8')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['submenu__item']"
                [id_object]="objectChoosing._id">
              </app-borders-config>
  
              
  
              <!-- Bo tròn -->
              <div class="my-3">
                <div class="config-name mb-0">
                  <p>{{'bo_tron' | translate}}</p>
                  <nz-input-number [nzMin]="0"  [ngModel]="class['submenu__item']['border-radius'] | vhnumber"
                    (ngModelChange)="
                      class['submenu__item']['border-radius'] = $event + 'px'
                    " (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0"  [ngModel]="class['submenu__item']['border-radius'] | vhnumber"
                  (ngModelChange)="
                    class['submenu__item']['border-radius'] = $event + 'px'
                  " (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </li>
            <!-- Cấu hình đổ bóng submenu-->
            <li class="pl-2" nz-submenu nzTitle="{{'do_bong_chung' | translate}}" [(nzOpen)]="openMap.menu25"
              (nzOpenChange)="openHandler('menu25')">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['submenu__container']"
                [shadowConfig]="config['submenu_box-shadow-wrapper']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>
            <li class="pl-2" nz-submenu nzTitle="{{'do_bong_tung_muc' | translate}}" [(nzOpen)]="openMap.menu9" 
              (nzOpenChange)="openHandler('menu9')">
              <app-shadow-config [device]="device" [config]="config" [class]="class"
                [shadowClass]="class['submenu__item']" [shadowConfig]="config['submenu_box-shadow']"
                [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>
            <!-- Cấu hình màu nền -->
            <li class="pl-2" nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu10"
              (nzOpenChange)="openHandler('menu10')">
              <div class="container-color">
                <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                  [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'submenu')"
                  nz-tooltip [disabled]="config[fieldConfigGradient[6]].gradient_check"></button>
              </div>
              <div class="color-pick">
                <span class="title w-50">{{'chon_mau' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['submenu__item']['background-color']"
                  [style.background]="class['submenu__item']['background-color']" (colorPickerClose)="updateObject()"
                  [cpPositionRelativeToArrow]="true" [disabled]="config[fieldConfigGradient[6]].gradient_check" />
              </div>
              <div class="mr-2 mb-4 mt-4 view-more" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 7px;
              ">
                <p class="discover_text" (click)="openViewAll(styles_field[5])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{'mau_gradient' | translate}} &#8594;
                </p>
              </div>
              <!-- Mở popup so sánh màu tương phản -->
              <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
              nz-row (click)="openColorContrast('menu_con')" nz-tooltip
              [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
              style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;"
              [disabled]="config[fieldConfigGradient[6]].gradient_check">
                {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
              </button>
            </li>
            <!-- Cấu hình khoảng cách giữa các menu-item -->
            <li class="pl-2" nz-submenu nzTitle="{{'khoang_cach' | translate}}" [(nzOpen)]="openMap.menu11" 
              (nzOpenChange)="openHandler('menu11')">
              <div class="field-format-font">
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_menu_cha_va_con' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="30" [ngModel]="
                      class['submenu__container']['margin-top'] | vhnumber
                    " (ngModelChange)="
                      class['submenu__container']['margin-top'] = $event + 'px'
                    " (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="class['submenu__container']['margin-top'] | vhnumber"
                  (ngModelChange)="
                    class['submenu__container']['margin-top'] = $event + 'px'
                  " (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <div class="field-format-font">
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_menu_con' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100"
                    [ngModel]="class['submenu__item']['margin-bottom'] | vhnumber" (ngModelChange)="
                      class['submenu__item']['margin-bottom'] = $event + 'px'
                    " (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [(ngModel)]="class['submenu__item--content']['margin-bottom']"
                  (ngModelChange)="
                    class['submenu__item']['margin-bottom'] = $event + 'px'
                  " (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <div class="flex flex-col">
                <p>{{'vi_tri_menu_con' | translate}}</p>
                <!-- select -->
                <nz-select [(ngModel)]="config.position_childmenu" (ngModelChange)="updateConfig()">
                  <nz-option *ngFor="let option of positionChildMenus" [nzValue]="option.value" [nzLabel]="option.label | translate"></nz-option>
                </nz-select>  
              </div>
            </li>
            <!-- Cấu hình biểu tượng -->
            <li class="pl-2" nz-submenu nzTitle="{{'bieu_tuong' | translate}}"  [(nzOpen)]="openMap.menu12"
              (nzOpenChange)="openHandler('menu12')">
              <div class="field-format-font">
                <!-- Vị trí của icon trước và chữ -->
                <div *ngIf="
                    class['submenu__item--content']['justify-content'] ==
                    'space-between'
                  " class="mt-3">
                  <p style="line-height: 1.5">{{'vi_tri_cua_icon_truoc_va_chu' | translate}}</p>
                  <nz-radio-group [(ngModel)]="
                      class['submenu__item--content-left']['justify-content']
                    " (ngModelChange)="updateClass()">
                    <label nz-radio nzValue="center">{{'canh_giua' | translate}}</label>
                    <label nz-radio nzValue="flex-start">{{'canh_trai' | translate}}</label>
                    <label nz-radio nzValue="flex-end">{{'canh_phai' | translate}}</label>
                  </nz-radio-group>
                </div>
                <!-- Icon trước -->
                <p style="font-weight: 500; margin-top: 30px; line-height: 1.5">
                  {{'icon_truoc' | translate}}
                </p>
                <!-- Kích thước (icon trước) -->
                <div class="mb-2">
                  <div class="config-name mb-0">
                    <p>{{ 'kich_thuoc' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                        class['submenu__item--icon-before']['font-size']
                          | vhnumber
                      " (ngModelChange)="
                        class['submenu__item--icon-before']['font-size'] =
                          $event + 'px'
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                      class['submenu__item--icon-before']['font-size'] | vhnumber
                    " (ngModelChange)="
                      class['submenu__item--icon-before']['font-size'] =
                        $event + 'px'
                    " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- {{'khoang_cach_ben_trai' | translate}} (icon trước) -->
                <div class="mb-2">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach_ben_trai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                        class['submenu__item--icon-before']['margin-left']
                          | vhnumber
                      " (ngModelChange)="
                        class['submenu__item--icon-before']['margin-left'] =
                          $event + 'px'
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                      class['submenu__item--icon-before']['margin-left']
                        | vhnumber
                    " (ngModelChange)="
                      class['submenu__item--icon-before']['margin-left'] =
                        $event + 'px'
                    " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- {{'khoang_cach_ben_phai' | translate}} (icon trước) -->
                <div class="mb-2">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach_ben_phai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                        class['submenu__item--icon-before']['margin-right']
                          | vhnumber
                      " (ngModelChange)="
                        class['submenu__item--icon-before']['margin-right'] =
                          $event + 'px'
                      " (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                      class['submenu__item--icon-before']['margin-right']
                        | vhnumber
                    " (ngModelChange)="
                      class['submenu__item--icon-before']['margin-right'] =
                        $event + 'px'
                    " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Icon sau -->
                <p style="font-weight: 500; margin-top: 30px; line-height: 1.5">
                  {{'icon_sau' | translate}}
                </p>
                <!-- Hiển thị icon đuôi -->
                <div class="config-name">
                  <p>{{'hien_thi_icon_duoi' | translate}}</p>
                  <nz-switch [(ngModel)]="config['icon_submenu']['show_icon_sub']"
                    (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <div *ngIf="config['icon_submenu']['show_icon_sub']">
                  <!-- Vị trí -->
                  <div class="mt-4">
                    <p>{{'vi_tri' | translate}}</p>
                    <nz-radio-group [(ngModel)]="
                        class['submenu__item--content']['justify-content']
                      " (ngModelChange)="
                        handleSetIconAfterPosition('submenu'); updateObject()
                      ">
                      <label nz-radio nzValue="center">{{'canh_giua' | translate}}</label>
                      <label nz-radio nzValue="space-between">{{'canh_phai' | translate}}</label>
                    </nz-radio-group>
                  </div>
                  <!-- Font -->
                  <div class="config-name">
                    <p>Font</p>
                    <mat-form-field style="width: 50% !important">
                      <mat-select [(value)]="config['icon_submenu']['name_icon']"
                        [(ngModel)]="config['icon_submenu']['name_icon']" (ngModelChange)="updateObject()">
                        <mat-select-trigger>
                          <mat-icon class="mr-2">{{
                            config["icon_submenu"]["name_icon"]
                            }}</mat-icon>
                        </mat-select-trigger>
                        <mat-option *ngFor="let icon of optionsIcon" [value]="icon.icon">
                          <mat-icon class="mr-2">{{ icon.icon }}</mat-icon>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div class="mb-2">
                    <div class="config-name mb-0">
                      <p>{{'kich_thuoc' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                          class['submenu__item--icon']['font-size'] | vhnumber
                        " (ngModelChange)="
                          class['submenu__item--icon']['font-size'] =
                            $event + 'px'
                        " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                        class['submenu__item--icon']['font-size'] | vhnumber
                      " (ngModelChange)="
                        class['submenu__item--icon']['font-size'] = $event + 'px'
                      " (nzOnAfterChange)="updateClass()" style="width: 40%">
                    </nz-slider>
                  </div>
                  <!-- Màu icon (icon sau) -->
                  <div class="config-name">
                    <p>{{'mau_icon' | translate}}</p>
                    <input class="input-color w-50" type="button" [cpPositionRelativeToArrow]="true"
                      [cpOKButton]="true" [(colorPicker)]="class['submenu__item--icon']['color']"
                      [style.background]="class['submenu__item--icon']['color']" (colorPickerClose)="updateClass()" />
                  </div>
                  <!-- {{'khoang_cach_ben_trai' | translate}} (icon sau) -->
                  <div class="mb-2">
                    <div class="config-name mb-0">
                      <p>{{'khoang_cach_ben_trai' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                          class['submenu__item--icon']['margin-left'] | vhnumber
                        " (ngModelChange)="
                          class['submenu__item--icon']['margin-left'] =
                            $event + 'px'
                        " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                        class['submenu__item--icon']['margin-left'] | vhnumber
                      " (ngModelChange)="
                        class['submenu__item--icon']['margin-left'] =
                          $event + 'px'
                      " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                  <!-- {{'khoang_cach_ben_phai' | translate}} (icon sau) -->
                  <div class="mb-2">
                    <div class="config-name mb-0">
                      <p>{{'khoang_cach_ben_phai' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                          class['submenu__item--icon']['margin-right'] | vhnumber
                        " (ngModelChange)="
                          class['submenu__item--icon']['margin-right'] =
                            $event + 'px'
                        " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                        class['submenu__item--icon']['margin-right'] | vhnumber
                      " (ngModelChange)="
                        class['submenu__item--icon']['margin-right'] =
                          $event + 'px'
                      " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                  <!-- Vị trí ngang -->
                  <!-- <div class="mb-2">
                                    <div class="config-name">
                                        <p>Vị trí ngang</p>
                                        <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                                            [ngModel]="class['submenu__item--icon']['width'] | vhnumber"
                                            (ngModelChange)="class['submenu__item--icon']['width'] = $event + '%';"
                                            (nzBlur)="updateObject()">
                                        </nz-input-number>
                                    </div>
                                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                                        [ngModel]="class['submenu__item--icon']['width'] | vhnumber"
                                        (ngModelChange)="class['submenu__item--icon']['width'] = $event + '%';"
                                        (nzOnAfterChange)="updateObject()">
                                    </nz-slider>
                                </div> -->
                  <!-- Vị trí dọc -->
                  <div class="mb-2">
                    <div class="config-name">
                      <p>{{'vi_tri_doc' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                        [ngModel]="class['submenu__item--icon']['top'] | vhnumber" (ngModelChange)="
                          class['submenu__item--icon']['top'] = $event + '%'
                        " (nzBlur)="updateClass()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['submenu__item--icon']['top'] | vhnumber" (ngModelChange)="
                        class['submenu__item--icon']['top'] = $event + '%'
                      " (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                </div>
              </div>
            </li>

            <!-- Cấu hình thanh cuộn -->
            <li class="pl-2" nz-submenu [nzTitle]="'thanh_cuon' | translate" [(nzOpen)]="openMap.menu20" (nzOpenChange)="openHandler('menu20')">
              <!-- Hiển thị thanh cuộn khi quá dài -->
              <div class="config-name">
                <p>{{'hien_thi_thanh_cuon_khi_qua_dai' | translate}}</p>
                <nz-switch 
                  [(ngModel)]="config['scrollbar']['is_show_scrollbar']"
                  (ngModelChange)="updateScrollbar($event)"></nz-switch>
              </div>
              <div *ngIf="config['scrollbar']['is_show_scrollbar']">
                <!-- Số lượng hiển thị tối đa -->
                <div>
                  <div class="config-name">
                    <p>{{'so_luong_hien_thi_toi_da' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" 
                      [(ngModel)]="config['scrollbar']['max_item_count']" 
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" 
                    [ngModel]="config['scrollbar']['max_item_count']"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
                <!-- Thanh cuộn -->
                <!-- Độ rộng thanh cuộn -->
                <div>
                  <div class="config-name">
                    <p>{{'do_rong_thanh_cuon' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100"
                      [ngModel]="config['scrollbar']['width'] | vhnumber"
                      (ngModelChange)="config['scrollbar']['width'] = $event +'px'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div> 
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" 
                      [ngModel]="config['scrollbar']['width'] | vhnumber"
                      (ngModelChange)="config['scrollbar']['width'] = $event +'px'"
                      (nzOnAfterChange)="updateConfig()">
                    </nz-slider>
                  </div>
                </div>
                <!-- Bo góc thanh cuộn -->
                <div>
                  <div class="config-name">
                    <p>{{'bo_goc_thanh_cuon' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100"
                      [ngModel]="config['scrollbar']['border-radius'] | vhnumber"
                      (ngModelChange)="config['scrollbar']['border-radius'] = $event +'px'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div> 
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="100" 
                      [ngModel]="config['scrollbar']['border-radius'] | vhnumber"
                      (ngModelChange)="config['scrollbar']['border-radius'] = $event +'px'"
                      (nzOnAfterChange)="updateConfig()">
                    </nz-slider>
                  </div>
                </div>
                <!-- Màu nền thanh cuộn -->
                <div class="config-name mt-4">
                  <p>{{'mau_nen_thanh_cuon' | translate}}</p>
                  <div>
                    <input class="input-color" type="button"
                      [cpOKButton]="true" 
                      [style.background]="config['scrollbar']['background-color']"
                      [(colorPicker)]="config['scrollbar']['background-color']"
                      (colorPickerClose)="updateConfig()" />
                  </div>
                </div>
                <!-- Màu thanh cuộn -->
                <div class="config-name mt-4">
                  <p>{{'mau_thanh_keo' | translate}}</p>
                  <div>
                    <input class="input-color" type="button"
                      [cpOKButton]="true" 
                      [style.background]="config['scrollbar']['thumb-background-color']"
                      [(colorPicker)]="config['scrollbar']['thumb-background-color']"
                      (colorPickerClose)="updateConfig()" />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <!-- MÀU KHI CHỌN MENU -->
        <li nz-submenu nzTitle="{{'cau_hinh_khi_chon_menu' | translate}}">
          <ul>
            <!-- Màu chữ -->
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item.color
                  " [style.background]="
                    config.desktop_background_active_menu_item.color
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <!-- Màu nền -->
            <div class="config-name">
              <p class="title-border">{{'mau_nen' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item.background_color
                  " [style.background]="
                    config.desktop_background_active_menu_item.background_color
                  " (colorPickerClose)="updateObject()" [disabled]="config[fieldConfigGradient[7]].gradient_check" />
              </div>
            </div>
            <div class="mr-2 mb-4 mt-4 view-more" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 7px;
            ">
              <p class="discover_text" (click)="openViewAll(styles_field[6])"
                style="cursor: pointer; text-align: left; margin: 0">
                {{'mau_gradient' | translate}} &#8594;
              </p>
            </div>
            <!-- Mở popup so sánh màu tương phản -->
            <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
            nz-row (click)="openColorContrast('khi_chon_menu')" nz-tooltip
            [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
            style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;"
            [disabled]="config[fieldConfigGradient[7]].gradient_check">
              {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
            </button>
  
            <!-- {{'mau_icon_sau' | translate}}-->
            <div class="config-name">
              <p class="title-border">{{'mau_icon_truoc' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_background_active_menu_item.color_icon_before_active"
                  [style.background]="config.desktop_background_active_menu_item.color_icon_before_active"
                  (colorPickerClose)="updateObject()" />
  
              </div>
            </div>
  
            <!-- {{'mau_icon_sau' | translate}}-->
            <div class="config-name">
              <p class="title-border">{{'mau_icon_sau' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item.color_icon_after_active
                  " [style.background]="
                    config.desktop_background_active_menu_item.color_icon_after_active
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <!-- Gạch chân -->
            <div class="item-border-size">
              <p>{{'chon_kieu_gach_chan' | translate}}: </p>
              <nz-select [(ngModel)]="config.desktop_background_active_menu_item.text_decoration_line"
                (ngModelChange)="updateConfig()" nzPlaceHolder="{{'chon_kieu_gach_chan' | translate}}">
                <nz-option nzValue="underline" nzLabel="Dưới"></nz-option>
                <nz-option nzValue="overline" nzLabel="Trên"></nz-option>
                <nz-option nzValue="line-through" nzLabel="Gạch ngang"></nz-option>
                <nz-option nzValue="none" nzLabel="không"></nz-option>
              </nz-select>
              <ng-container *ngIf="config.desktop_background_active_menu_item.text_decoration_line != 'none'">
                <!-- Độ dày -->
                <div class="config-name mb-0">
                  <p>{{'do_day' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                    config.desktop_background_active_menu_item
                      .text_decoration_thickness | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.text_decoration_thickness =
                      $event + '%'
                  " (nzBlur)="updateObject()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                      config.desktop_background_active_menu_item
                        .text_decoration_thickness | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.text_decoration_thickness =
                        $event + '%'
                    " (nzOnAfterChange)="updateObject()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
                <ng-container *ngIf="config.desktop_background_active_menu_item.text_decoration_line == 'underline'">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                      config.desktop_background_active_menu_item
                        .text_underline_offset | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.text_underline_offset =
                        $event + '%'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
  
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                        config.desktop_background_active_menu_item
                          .text_underline_offset | vhnumber
                      " (ngModelChange)="
                        config.desktop_background_active_menu_item.text_underline_offset =
                          $event + '%'
                      " (nzOnAfterChange)="updateObject()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </ng-container>
                <!-- Màu gạch chân -->
                <div class="config-name">
                  <p class="title-border">{{'mau_gach_chan' | translate}}</p>
                  <div style="width: 50%; max-width: 50%">
                    <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                      config.desktop_background_active_menu_item
                        .text_decoration_color
                    " [style.background]="
                      config.desktop_background_active_menu_item
                        .text_decoration_color
                    " (colorPickerClose)="updateObject()" />
                  </div>
                </div>
                <!-- Khoảng cách giữa các dòng -->
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_dong' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1" [ngModel]="config.desktop_background_active_menu_item.line_height"
                  (ngModelChange)="config.desktop_background_active_menu_item.line_height = $event + ''" (nzBlur)="updateObject()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [ngModel]="config.desktop_background_active_menu_item.line_height"
                  (ngModelChange)="config.desktop_background_active_menu_item.line_height = $event + ''" (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              </ng-container>
            </div>
            <!-- viền khi chọn -->
            <li  nz-submenu nzTitle="{{'cau_hinh_vien_khi_chon' | translate}}">
              
  
              <div class="pl-2">
                <div>
                  <div class="item-border">
                    <p class="m-0 title-border">{{'kieu_vien' | translate}}</p>
                    <div class="field-widget">
                      <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder" nzPopoverTrigger="click">
                        <mat-icon>border_style</mat-icon>
                      </button>
                    </div>
                    <!-- Menu các kiểu viền khác -->
                    <nz-dropdown-menu #menuBorder="nzDropdownMenu">
                      <ul nz-menu>
                        <!-- Kiểu viền solid -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'solid';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{active:config.desktop_background_active_menu_item.border_style == 'solid'}">
                            <div class="icon-field">
                              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                                  fill="#000000" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền double -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'double';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item
                                .border_style == 'double'
                          }">
                            <div class="icon-field">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-border-style" viewBox="0 0 16 16">
                                <path
                                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền dashed -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'dashed';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item
                                .border_style == 'dashed'
                          }">
                            <div class="icon-field">
                              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                                  fill="#000000" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền dotted -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'dotted';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item
                                .border_style == 'dotted'
                          }">
                            <div class="icon-field">
                              <i class="bi bi-three-dots"></i>
                            </div>
                          </button>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                </div>
                <div class="config-name">
                  <p class="title-border">{{'mau_vien' | translate}}</p>
                  <div style="width: 50%; max-width: 50%">
                    <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                      config.desktop_background_active_menu_item.border_color
                    " [style.background]="
                      config.desktop_background_active_menu_item.border_color
                    " (colorPickerClose)="updateObject()" />
                  </div>
                </div>
              
  
  
  
                <!-- Bo tròn -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_tren' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_top_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_top_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_top_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_top_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_duoi' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_bottom_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_bottom_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_bottom_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_bottom_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_trai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_left_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_left_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_left_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_left_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_phai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_right_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_right_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_right_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_right_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'bo_tron_vien' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_radius
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_radius =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_radius
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_radius =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
              </div>
  
            </li>
          </ul>
        </li>
  
         <!-- MÀU KHI CHỌN MENU CON-->
         <li nz-submenu nzTitle="{{'cau_hinh_khi_chon_menu_con' | translate}}">
          <ul>
            <!-- Màu chữ -->
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item_sub.color
                  " [style.background]="
                    config.desktop_background_active_menu_item_sub.color
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <!-- Màu nền -->
            <div class="config-name">
              <p class="title-border">{{'mau_nen' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item_sub.background_color
                  " [style.background]="
                    config.desktop_background_active_menu_item_sub.background_color
                  " (colorPickerClose)="updateObject()" [disabled]="config[fieldConfigGradient[8]].gradient_check" />
              </div>
            </div>
            <div class="mr-2 mb-4 mt-4 view-more" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 7px;
            ">
              <p class="discover_text" (click)="openViewAll(styles_field[7])"
                style="cursor: pointer; text-align: left; margin: 0">
                {{'mau_gradient' | translate}} &#8594;
              </p>
            </div>
            <!-- Mở popup so sánh màu tương phản -->
            <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
            nz-row (click)="openColorContrast('khi_chon_menu_con')" nz-tooltip
            [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
            style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;"
            [disabled]="config[fieldConfigGradient[8]].gradient_check">
              {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
            </button>
  
            <!-- {{'mau_icon_sau' | translate}}-->
            <div class="config-name">
              <p class="title-border">{{'mau_icon_truoc' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_background_active_menu_item_sub.color_icon_before_active"
                  [style.background]="config.desktop_background_active_menu_item_sub.color_icon_before_active"
                  (colorPickerClose)="updateObject()" />
  
              </div>
            </div>
  
            <!-- {{'mau_icon_sau' | translate}}-->
            <div class="config-name">
              <p class="title-border">{{'mau_icon_sau' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item_sub.color_icon_after_active
                  " [style.background]="
                    config.desktop_background_active_menu_item_sub.color_icon_after_active
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <!-- Gạch chân -->
            <div class="item-border-size">
              <p>{{'chon_kieu_gach_chan' | translate}}: </p>
              <nz-select [(ngModel)]="config.desktop_background_active_menu_item_sub.text_decoration_line"
                (ngModelChange)="updateConfig()" nzPlaceHolder="{{'chon_kieu_gach_chan' | translate}}">
                <nz-option nzValue="underline" nzLabel="Dưới"></nz-option>
                <nz-option nzValue="overline" nzLabel="Trên"></nz-option>
                <nz-option nzValue="line-through" nzLabel="Gạch ngang"></nz-option>
                <nz-option nzValue="none" nzLabel="không"></nz-option>
              </nz-select>
              <ng-container *ngIf="config.desktop_background_active_menu_item_sub.text_decoration_line != 'none'">
                <!-- Độ dày -->
                <div class="config-name mb-0">
                  <p>{{'do_day' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                    config.desktop_background_active_menu_item_sub
                      .text_decoration_thickness | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item_sub.text_decoration_thickness =
                      $event + '%'
                  " (nzBlur)="updateObject()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                      config.desktop_background_active_menu_item_sub
                        .text_decoration_thickness | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.text_decoration_thickness =
                        $event + '%'
                    " (nzOnAfterChange)="updateObject()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
                <ng-container *ngIf="config.desktop_background_active_menu_item_sub.text_decoration_line == 'underline'">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                      config.desktop_background_active_menu_item_sub
                        .text_underline_offset | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.text_underline_offset =
                        $event + '%'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
  
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                        config.desktop_background_active_menu_item_sub
                          .text_underline_offset | vhnumber
                      " (ngModelChange)="
                        config.desktop_background_active_menu_item_sub.text_underline_offset =
                          $event + '%'
                      " (nzOnAfterChange)="updateObject()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </ng-container>
                <!-- Màu gạch chân -->
                <div class="config-name">
                  <p class="title-border">{{'mau_gach_chan' | translate}}</p>
                  <div style="width: 50%; max-width: 50%">
                    <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                      config.desktop_background_active_menu_item_sub
                        .text_decoration_color
                    " [style.background]="
                      config.desktop_background_active_menu_item_sub
                        .text_decoration_color
                    " (colorPickerClose)="updateObject()" />
                  </div>
                </div>
                <!-- Khoảng cách giữa các dòng -->
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_dong' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1" [ngModel]="config.desktop_background_active_menu_item_sub.line_height"
                  (ngModelChange)="config.desktop_background_active_menu_item_sub.line_height = $event + ''" (nzBlur)="updateObject()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [ngModel]="config.desktop_background_active_menu_item_sub.line_height"
                  (ngModelChange)="config.desktop_background_active_menu_item_sub.line_height = $event + ''" (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              </ng-container>
            </div>
            <!-- viền khi chọn -->
            <li  nz-submenu nzTitle="{{'cau_hinh_vien_khi_chon_menu_con' | translate}}">
              <div class="pl-2">
                <div>
                  <div class="item-border">
                    <p class="m-0 title-border">{{'kieu_vien' | translate}}</p>
                    <div class="field-widget">
                      <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder" nzPopoverTrigger="click">
                        <mat-icon>border_style</mat-icon>
                      </button>
                    </div>
                    <!-- Menu các kiểu viền khác -->
                    <nz-dropdown-menu #menuBorder="nzDropdownMenu">
                      <ul nz-menu>
                        <!-- Kiểu viền solid -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item_sub.border_style =
                              'solid';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{active:config.desktop_background_active_menu_item_sub.border_style == 'solid'}">
                            <div class="icon-field">
                              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                                  fill="#000000" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền double -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item_sub.border_style =
                              'double';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item_sub
                                .border_style == 'double'
                          }">
                            <div class="icon-field">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-border-style" viewBox="0 0 16 16">
                                <path
                                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền dashed -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item_sub.border_style =
                              'dashed';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item_sub
                                .border_style == 'dashed'
                          }">
                            <div class="icon-field">
                              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                                  fill="#000000" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền dotted -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item_sub.border_style =
                              'dotted';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item_sub
                                .border_style == 'dotted'
                          }">
                            <div class="icon-field">
                              <i class="bi bi-three-dots"></i>
                            </div>
                          </button>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                </div>
                <div class="config-name">
                  <p class="title-border">{{'mau_vien' | translate}}</p>
                  <div style="width: 50%; max-width: 50%">
                    <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                      config.desktop_background_active_menu_item_sub.border_color
                    " [style.background]="
                      config.desktop_background_active_menu_item_sub.border_color
                    " (colorPickerClose)="updateObject()" />
                  </div>
                </div>
                <!-- Bo tròn -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_tren' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item_sub.border_top_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.border_top_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item_sub.border_top_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item_sub.border_top_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_duoi' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item_sub.border_bottom_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.border_bottom_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item_sub.border_bottom_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item_sub.border_bottom_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_trai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item_sub.border_left_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.border_left_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item_sub.border_left_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item_sub.border_left_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_phai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item_sub.border_right_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.border_right_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item_sub.border_right_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item_sub.border_right_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'bo_tron_vien' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item_sub.border_radius
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item_sub.border_radius =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item_sub.border_radius
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item_sub.border_radius =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
              </div>
  
            </li>
          </ul>
        </li>
        <!-- HIỆU ỨNG MENU -->
        <li (nzOpenChange)="openHandler('menu22')" [(nzOpen)]="openMap.menu22" nz-submenu nzTitle="{{'hieu_ung_menu' | translate}}">
          <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [cursorClass]="class['menu__item']" [effect_hover]="effect_hover" [customize]="customize"
            [effectFileUsing]="'menu-vertical'">
          </app-choose-animations-config>
        </li>
        <!-- HIỆU ỨNG MENU  CON-->
        <li (nzOpenChange)="openHandler('menu23')" [(nzOpen)]="openMap.menu23" nz-submenu nzTitle="{{'hieu_ung_menu_con' | translate}}">
          <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetailChild)="openAnimationDetailChild($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [cursorClass]="class['submenu']" [effect_hover]="effect_hover" [customize]="customize"
            [isParent]="false" [effectFileUsing]="'menu-vertical'">
          </app-choose-animations-config>
        </li>
        <!-- HIỆU ỨNG XUẤT HIỆN MENU CON -->
        <li (nzOpenChange)="openAnimationAppear('submenu'); openHandler('menu15')" nz-submenu nzTitle="{{'hieu_ung_xuat_hien_menu_con' | translate}}" [(nzOpen)]="openMap.menu15">
          <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
            [device]="device">
          </app-animations-config>
        </li>
        <!-- HIỆU ỨNG XUẤT HIỆN HỘP THOẠI -->
        <li (nzOpenChange)="openAnimationAppear('block_hover_blank'); openHandler('menu18')" nz-submenu nzTitle="{{'hieu_ung_xuat_hien_hop_thoai' | translate}}" [(nzOpen)]="openMap.menu18">
          <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
            [device]="device">
          </app-animations-config>
        </li>

        <!-- VỊ TRÍ KHỐI HỘP THOẠI -->
        <li nz-submenu nzTitle="{{'vi_tri_khoi_hop_thoai' | translate}}" [(nzOpen)]="openMap.menu16"
        (nzOpenChange)="openHandler('menu16')">
          <div class="config-name">
            <p class="m-0">{{'khoang_cach' | translate}}</p>
            <nz-input-number [nzMin]="0" [(ngModel)]="config['popup_distance']" (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
        </li>
      </ul>
      <!-- Kiểu hiện thị điện thoại -->
      <ul *ngIf="config['type'] == 'vertical' && class['mobilemenu']?.width" nz-menu nzMode="inline">
        <!-- Chọn kiểu hiển thị -->
        <li nz-submenu nzTitle="{{'chon_kieu_hien_thi' | translate}}">
          <div class="config-name" style="gap:4px">
            <p>{{'kieu_hien_thi' | translate}}:</p>
            <nz-select style="width:60%" [(ngModel)]="config['type']" nzPlaceHolder="{{'chon_kieu_hien_thi' | translate}}"
              (ngModelChange)="handleChangeTypeMenu($event)">
              <nz-option nzValue="horizontal" nzLabel="{{'doc' | translate}}"></nz-option>
              <nz-option nzValue="vertical" nzLabel="{{'dien_thoai' | translate}}"></nz-option>
            </nz-select>
          </div>
          <div *ngIf="config['type']=='vertical'" class="config-name mt-2" style="gap:4px">
            <p>{{'vi_tri_hien_thi' | translate}}:</p>
            <nz-select style="width:60%" [(ngModel)]="config['position']" nzPlaceHolder="{{'chon_kieu_hien_thi' | translate}}"
              (ngModelChange)="handleChangePosition($event)">
              <nz-option nzValue="absolute" nzLabel="{{'absolute' | translate}}"></nz-option>
              <nz-option nzValue="relative" nzLabel="{{'relative' | translate}}"></nz-option>
            </nz-select>
          </div>
          <ng-container *ngIf="config['position'] == 'absolute'">
            <div class="my-3">
              <div class="config-name mb-0">
                <p>{{'khoang_cach_ben_tren' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100"
                [ngModel]="class['mobilemenu__list']['margin-top'] | vhnumber"
                (ngModelChange)="class['mobilemenu__list']['margin-top'] = $event + 'px'"
                (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="100"
              [ngModel]="class['mobilemenu__list']['margin-top'] | vhnumber"
              (ngModelChange)="class['mobilemenu__list']['margin-top'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
            <div class="my-3">
              <div class="config-name mb-0">
                <p>{{'chieu_cao' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100"
                [ngModel]="class['mobilemenu__list']['max-height'] | vhnumber"
                (ngModelChange)="class['mobilemenu__list']['max-height'] = $event + 'vh'"
                (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="100"
              [ngModel]="class['mobilemenu__list']['max-height'] | vhnumber"
              (ngModelChange)="class['mobilemenu__list']['max-height'] = $event + 'vh'"
              (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </ng-container>
        </li>
        <!-- BIỂU TƯỢNG MENU -->
        <li nz-submenu [nzTitle]="'bieu_tuong_va_mau' | translate">
          <div class="field-symbol mt-0">
            <!-- Kích thước -->
            <div class="">
              <div class="config-name my-0">
                <p>{{'kich_thuoc' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class['mobilemenu__toggle']['font-size'] | vhnumber"
                  (ngModelChange)="
                    class['mobilemenu__toggle']['font-size'] = $event + 'px'
                  " (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class['mobilemenu__toggle']['font-size'] | vhnumber"
                (ngModelChange)="
                  class['mobilemenu__toggle']['font-size'] = $event + 'px'
                " (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
            <!-- Màu biểu tượng -->
            <div class="config-name">
              <p>{{'mau_bieu_tuong' | translate}}</p>
              <div style="width: 40%; max-width: 40%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [style.background]="class['mobilemenu__toggle']['color']"
                  [cpOKButton]="true" [(colorPicker)]="class['mobilemenu__toggle']['color']" (colorPickerClose)="updateClass()" />
              </div>
            </div>
            <!-- Có đổi biểu tượng khi đóng mở -->
            <div class="config-name">
              <p>{{'doi_bieu_tuong_khi_dong_mo' | translate}}</p>
              <div style="width: 40%; max-width: 40%; text-align: right;">
                <nz-switch [(ngModel)]="config['has_change_icon']" (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>
            </div>
            <!-- Màu nền -->
            <div class="config-name">
              <p>{{'mau_nen' | translate}}</p>
              <div style="width: 40%; max-width: 40%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [style.background]="class['mobilemenu']['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['mobilemenu']['background-color']" (colorPickerClose)="updateClass()" />
              </div>
            </div>
            <!-- Canh lề -->
            <div class="mt-4 mb-3">
              <p class="title-font">{{'canh_le' | translate}}</p>
              <div class="field-row" style="justify-content: normal">
                <button nz-button class="font-text-btn" style="width: 35px; flex: none; border: none" [nzType]="
                    class['mobilemenu__toggle']['justify-content'] == 'flex-start'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['mobilemenu__toggle']['justify-content'] = 'flex-start';
                    updateClass()
                  ">
                  <i nz-icon nzType="align-left" nzTheme="outline"></i>
                </button>
                <button nz-button class="font-text-btn" style="width: 35px; flex: none; border: none" [nzType]="
                    class['mobilemenu__toggle']['justify-content'] == 'center'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['mobilemenu__toggle']['justify-content'] = 'center';
                    updateClass()
                  ">
                  <i nz-icon nzType="align-center" nzTheme="outline"></i>
                </button>
                <button nz-button class="font-text-btn" style="width: 35px; flex: none; border: none" [nzType]="
                    class['mobilemenu__toggle']['justify-content'] == 'flex-end'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['mobilemenu__toggle']['justify-content'] = 'flex-end';
                    updateClass()
                  ">
                  <i nz-icon nzType="align-right" nzTheme="outline"></i>
                </button>
              </div>
            </div>
            <!-- Khoảng đệm -->
            <div class="mt-4">
              <app-padding-config
                [objectChoosing]="objectChoosing"
                [device]="device"
                [class]="class"
                [classPadding]="class['mobilemenu__toggle']"
                [paddingConfigs]="[
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </div>
          </div>
        </li>
        <!-- BIỂU TƯỢNG MENU CON -->
        <li nz-submenu [nzTitle]="'bieu_tuong_menu_con' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <div class="field-format-font">
            <!-- Hiển thị icon -->
            <div class="config-name mb-0">
              <p>{{'hien_thi_icon' | translate}}</p>
              <nz-switch [(ngModel)]="config['icon_menu']['show_icon_sub']"
                (ngModelChange)="updateConfig(); updateCssMobileMenu()"></nz-switch>
            </div>
            <div *ngIf="config['icon_menu']['show_icon_sub']">
              <!-- Chọn icon -->
              <div class="config-name mt-0">
                <p>{{'chon_icon' | translate}}</p>
                <mat-form-field style="width: 50% !important">
                  <mat-select [(ngModel)]="config['icon_menu']['name_icon']"
                    (ngModelChange)="updateObject(); updateCssMobileMenu();">
                    <mat-select-trigger>
                      <mat-icon class="mr-2">{{config["icon_menu"]["name_icon"] }}</mat-icon>
                    </mat-select-trigger>
                    <mat-option *ngFor="let icon of optionsIcon" [value]="icon.icon">
                      <mat-icon class="mr-2">{{ icon.icon }}</mat-icon>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Kích thước -->
              <div class="mb-2">
                <div class="config-name mb-0">
                  <p>{{'kich_thuoc' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                      class['mobilemenu__item--icon']['font-size'] | vhnumber
                    " (ngModelChange)="
                      class['mobilemenu__item--icon']['font-size'] = $event + 'px'
                    " (nzBlur)="updateClass(); updateCssMobileMenu()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                    class['mobilemenu__item--icon']['font-size'] | vhnumber
                  " (ngModelChange)="
                    class['mobilemenu__item--icon']['font-size'] = $event + 'px'
                  " (nzOnAfterChange)="updateClass(); updateCssMobileMenu()">
                </nz-slider>
              </div>
              <!-- Màu icon (icon sau) -->
              <div class="config-name">
                <p>{{'mau_icon' | translate}}</p>
                <input class="input-color w-50" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="class['mobilemenu__item--icon']['color']"
                  [style.background]="class['mobilemenu__item--icon']['color']"
                  (colorPickerClose)="updateClass(); updateCssMobileMenu()" />
              </div>
            </div>
          </div>
        </li>
        <!-- CẤU HÌNH THANH CUỘN -->
        <li nz-submenu [nzTitle]="'thanh_cuon' | translate" [(nzOpen)]="openMap.menu21" (nzOpenChange)="openHandler('menu21')">
          <!-- Hiển thị thanh cuộn khi quá dài -->
          <div class="config-name">
            <p>{{'hien_thi_thanh_cuon_khi_qua_dai' | translate}}</p>
            <nz-switch 
              [(ngModel)]="config['scrollbar']['is_show_scrollbar']"
              (ngModelChange)="updateScrollbarMobile($event)"></nz-switch>
          </div>
          <div *ngIf="config['scrollbar']['is_show_scrollbar']">
            <!-- Số lượng hiển thị tối đa -->
            <div>
              <div class="config-name">
                <p>{{'so_luong_hien_thi_toi_da' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" 
                  [(ngModel)]="config['scrollbar']['max_item_count']" 
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="100" 
                [ngModel]="config['scrollbar']['max_item_count']"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
            <!-- Thanh cuộn -->
            <!-- Độ rộng thanh cuộn -->
            <div>
              <div class="config-name">
                <p>{{'do_rong_thanh_cuon' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100"
                  [ngModel]="config['scrollbar']['width'] | vhnumber"
                  (ngModelChange)="config['scrollbar']['width'] = $event +'px'"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div> 
              <div>
                <nz-slider [nzMin]="0" [nzMax]="100" 
                  [ngModel]="config['scrollbar']['width'] | vhnumber"
                  (ngModelChange)="config['scrollbar']['width'] = $event +'px'"
                  (nzOnAfterChange)="updateConfig()">
                </nz-slider>
              </div>
            </div>
            <!-- Bo góc thanh cuộn -->
            <div>
              <div class="config-name">
                <p>{{'bo_goc_thanh_cuon' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100"
                  [ngModel]="config['scrollbar']['border-radius'] | vhnumber"
                  (ngModelChange)="config['scrollbar']['border-radius'] = $event +'px'"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div> 
              <div>
                <nz-slider [nzMin]="0" [nzMax]="100" 
                  [ngModel]="config['scrollbar']['border-radius'] | vhnumber"
                  (ngModelChange)="config['scrollbar']['border-radius'] = $event +'px'"
                  (nzOnAfterChange)="updateConfig()">
                </nz-slider>
              </div>
            </div>
            <!-- Màu nền thanh cuộn -->
            <div class="config-name mt-4">
              <p>{{'mau_nen_thanh_cuon' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="config['scrollbar']['background-color']"
                  [(colorPicker)]="config['scrollbar']['background-color']"
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>
            <!-- Màu thanh cuộn -->
            <div class="config-name mt-4">
              <p>{{'mau_thanh_keo' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="config['scrollbar']['thumb-background-color']"
                  [(colorPicker)]="config['scrollbar']['thumb-background-color']"
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>
          </div>
        </li>
        <!-- CẤU HÌNH XUỐNG DÒNG -->
        <li nz-submenu [nzTitle]="'cau_hinh_xuong_dong' | translate" [(nzOpen)]="openMap.menu31" (nzOpenChange)="openHandler('menu31')">
          <div class="config-font mb-2">
            <!-- Xuống dòng -->
            <div class="config-name mb-0">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch [ngModel]="
                class['mobilemenu__item--content-inner']['white-space'] && 
                class['mobilemenu__item--content-inner']['white-space'] != 'nowrap'
              "
              (ngModelChange)="
                class['mobilemenu__item--content-inner']['white-space'] = $event ? 'normal' : 'nowrap'; 
                updateClass()
              ">
              </nz-switch>
            </div>
            <!-- Hiển thị số dòng -->
            <div *ngIf="class['mobilemenu__item--content-inner']['white-space'] != 'nowrap'" class="config-name mb-0 mt-2">
              <p>{{'hien_thi_so_dong' | translate}}</p>
              <nz-input-number [nzMin]="2" [nzMax]="10" [nzStep]="1"
                [ngModel]="class['mobilemenu__item--content-inner']['-webkit-line-clamp'] | vhnumber"
                (ngModelChange)="class['mobilemenu__item--content-inner']['-webkit-line-clamp'] = $event"
                (nzBlur)="updateLineNumber('mobilemenu__item--content-inner')">
              </nz-input-number>
            </div>
          </div>
        </li>
        <!-- CẤU HÌNH MENU CẤP * -->
        <li *ngFor="let menu of subMobileArray; let idMenu = index" nz-submenu [nzTitle]="languageService.translate('cau_hinh_menu_cap') + ' '+ idMenu"
        (nzOpenChange)="addAttrClass(idMenu)">
          
          <div class="config-name" *ngIf="idMenu == 0">
            <p>{{'hien_thi_san_menu_cap_0' | translate}}</p>
            <nz-switch [(ngModel)]="config['isOpenMenuDefault']" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
          <!-- Không cho phép đóng menu cấp 0 -->
          <div class="config-name" *ngIf="idMenu == 0 && config['isOpenMenuDefault']">
            <p>{{'khong_cho_phep_dong_menu_cap_0' | translate}}</p>
            <nz-switch 
              [(ngModel)]="config['is_prevent_to_close_menu_0']" 
              (ngModelChange)="updateConfig()">
            </nz-switch>
          </div>
          

          <ul *ngIf="class[menu]?.['letter-spacing']">
            <!-- Cấu hình Font chữ -->
            <li  class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}" [id]="idMenu" [(nzOpen)]="openMap.menu1"
              (nzOpenChange)="openHandler('menu1')">
              <div class="field-format-font menu-field">
                <div class="container-font field-font">
                  <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
                    [config]="config"  [staticdata]="staticdata" [textContentClass]="class[menu]"
                    [textWrapperClass]="class[menu]">
                  </app-text-format-config>
  
                  <!-- Giãn cách chữ -->
                  <div class="config-font">
                    <div class="config-name mb-0">
                      <p>{{'gian_cach_chu' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="30" [ngModel]="class[menu]['letter-spacing'] | vhnumber"
                        (ngModelChange)="
                          class[menu]['letter-spacing'] = $event + 'px'
                        " (nzBlur)="updateClass(); updateCssMobileMenu(idMenu)">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="class[menu]['letter-spacing'] | vhnumber"
                      (ngModelChange)="
                        class[menu]['letter-spacing'] = $event + 'px'
                      " (nzOnAfterChange)="
                        updateClass(); updateCssMobileMenu(idMenu)
                      ">
                    </nz-slider>
                  </div>
                  <!-- Chiều cao -->
                  <div class="config-font">
                    <div class="config-name mb-0">
                      <p>{{'chieu_cao' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="200" [ngModel]="class[menu]['height'] | vhnumber"
                        (ngModelChange)="class[menu]['height'] = $event + 'px'"
                        (nzBlur)="updateClass(); updateCssMobileMenu(idMenu)">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="200" [ngModel]="class[menu]['height'] | vhnumber"
                      (ngModelChange)="class[menu]['height'] = $event + 'px'" (nzOnAfterChange)="
                        updateClass(); updateCssMobileMenu(idMenu)
                      ">
                    </nz-slider>
                  </div>
                  <!-- Khoảng cách dòng -->
                  <div class="config-font">
                    <div class="config-name mb-0">
                      <p>{{'khoang_cach_dong' | translate}}</p>
                      <nz-input-number [nzMin]="0.5" [nzMax]="9" [nzStep]=".1" [ngModel]="class[menu]['line-height'] | vhnumber"
                        (ngModelChange)="
                          class[menu]['line-height'] = $event 
                        " (nzBlur)="updateClass(); updateCssMobileMenu(idMenu)">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0.5" [nzMax]="9" [nzStep]=".1" [ngModel]="class[menu]['line-height'] | vhnumber"
                      (ngModelChange)="
                        class[menu]['line-height'] = $event 
                      " (nzOnAfterChange)="
                        updateClass(); updateCssMobileMenu(idMenu)
                      ">
                    </nz-slider>
                  </div>
                  <!-- Thụt lề -->
                  <div class="config-font">
                    <div class="config-name mb-0">
                      <p>{{'thut_le' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="200" [ngModel]="class[menu]['padding-left'] | vhnumber"
                        (ngModelChange)="
                          class[menu]['padding-left'] = $event + 'px'
                        " (nzBlur)="updateClass(); updateCssMobileMenu(idMenu)">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="200" [ngModel]="class[menu]['padding-left'] | vhnumber"
                      (ngModelChange)="
                        class[menu]['padding-left'] = $event + 'px'
                      " (nzOnAfterChange)="
                        updateClass(); updateCssMobileMenu(idMenu)
                      ">
                    </nz-slider>
                  </div>
                </div>
              </div>
            </li>
            <!-- Cấu hình viền -->
            <li class="pl-2" nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class[menu]"
                [id_object]="objectChoosing._id">
              </app-borders-config>
              <!-- Bo tròn -->
              <div class="my-3">
                <div class="config-name mb-0">
                  <p>{{'bo_tron' | translate}}</p>
                  <nz-input-number [nzMin]="0"  [ngModel]="class[menu]['border-radius'] | vhnumber"
                    (ngModelChange)="class[menu]['border-radius'] = $event + 'px'"
                    (nzBlur)="updateClass(); updateCssMobileMenu(idMenu)">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0"  [ngModel]="class[menu]['border-radius'] | vhnumber"
                  (ngModelChange)="class[menu]['border-radius'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass(); updateCssMobileMenu(idMenu)">
                </nz-slider>
              </div>
            </li>
            <!-- Cấu hình màu nền -->
            <li class="pl-2" nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu3"
              (nzOpenChange)="openHandler('menu3')">
              <div class="container-color">
                <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                  [ngStyle]="{ 'background-color': background.bgColor }" (click)="
                    chooseBg(background, $event, 'mobilemenu', idMenu);
                    updateCssMobileMenu(idMenu)
                  " nz-tooltip></button>
              </div>
              <div class="color-pick">
                <span class="title w-50">{{'chon_mau' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class[menu]['background-color']"
                  [style.background]="class[menu]['background-color']"
                  (colorPickerClose)="updateObject(); updateCssMobileMenu(idMenu)" [cpPositionRelativeToArrow]="true" />
              </div>
            </li>
            <!-- Cấu hình khoảng cách giữa các mobilemenu-item -->
            <li class="pl-2" nz-submenu nzTitle="{{'khoang_cach' | translate}}" [(nzOpen)]="openMap.menu12" (click)="showSubMenu()"
              (nzOpenChange)="openHandler('menu12')">
              <div class="field-format-font">
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_menu_con' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class[menu]['margin-bottom'] | vhnumber"
                    (ngModelChange)="class[menu]['margin-bottom'] = $event + 'px'"
                    (nzBlur)="updateClass(); updateCssMobileMenu(idMenu)">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class[menu]['margin-bottom'] | vhnumber"
                  (ngModelChange)="class[menu]['margin-bottom'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass(); updateCssMobileMenu(idMenu)">
                </nz-slider>
              </div>
            </li>

            <!-- Cấu hình đổ bóng -->
            <li *ngIf="idMenu == 0" class="pl-2" nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu18"
              (nzOpenChange)="openHandler('menu18')">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['mobilemenu__list']"
                [shadowConfig]="config['mobile-box-shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>
            <!-- Cấu hình đường viền -->
            <li *ngIf="idMenu == 0" class="pl-2" nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMap.menu26"
              (nzOpenChange)="openHandler('menu26')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['mobilemenu__list']" [id_object]="objectChoosing._id">
              </app-borders-config>
            </li>
            <!-- Cấu hình đổ bóng -->
            <li *ngIf="idMenu == 0" class="pl-2" nz-submenu nzTitle="{{'bo_tron_chung' | translate}}" [(nzOpen)]="openMap.menu27"
              (nzOpenChange)="openHandler('menu27')">
              <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['mobilemenu__list']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>
            </li>
          </ul>
        </li>
        <li nz-submenu nzTitle="{{'cau_hinh_khi_chon_menu_cap' | translate}} 0">
          <!-- Hiển thị icon đuôi -->
          <div class="config-name">
            <p>{{'bat_active' | translate}}</p>
            <nz-switch [ngModel]="config.is_on_active_menu_mobile"
              (ngModelChange)="config.is_on_active_menu_mobile = $event; updateConfig()">
            </nz-switch>
          </div>
          <ul *ngIf="config.is_on_active_menu_mobile">
            <!-- Màu chữ -->
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item.color
                  " [style.background]="
                    config.desktop_background_active_menu_item.color
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <!-- Màu nền -->
            <div class="config-name">
              <p class="title-border">{{'mau_nen' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item.background_color
                  " [style.background]="
                    config.desktop_background_active_menu_item.background_color
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
  
            <!-- {{'mau_icon_sau' | translate}}-->
            <div class="config-name">
              <p class="title-border">{{'mau_icon_truoc' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_background_active_menu_item.color_icon_before_active"
                  [style.background]="config.desktop_background_active_menu_item.color_icon_before_active"
                  (colorPickerClose)="updateObject()" />
  
              </div>
            </div>
  
            <!-- {{'mau_icon_sau' | translate}}-->
            <div class="config-name">
              <p class="title-border">{{'mau_icon_sau' | translate}}</p>
              <div style="width: 50%; max-width: 50%">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                    config.desktop_background_active_menu_item.color_icon_after_active
                  " [style.background]="
                    config.desktop_background_active_menu_item.color_icon_after_active
                  " (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <!-- Gạch chân -->
            <div class="item-border-size">
              <p>{{'chon_kieu_gach_chan' | translate}}: </p>
              <nz-select [(ngModel)]="config.desktop_background_active_menu_item.text_decoration_line"
                (ngModelChange)="updateConfig()" nzPlaceHolder="{{'chon_kieu_gach_chan' | translate}}">
                <nz-option nzValue="underline" nzLabel="Dưới"></nz-option>
                <nz-option nzValue="overline" nzLabel="Trên"></nz-option>
                <nz-option nzValue="line-through" nzLabel="Gạch ngang"></nz-option>
                <nz-option nzValue="none" nzLabel="không"></nz-option>
              </nz-select>
              <ng-container *ngIf="config.desktop_background_active_menu_item.text_decoration_line != 'none'">
                <!-- Độ dày -->
                <div class="config-name mb-0">
                  <p>{{'do_day' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                    config.desktop_background_active_menu_item
                      .text_decoration_thickness | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.text_decoration_thickness =
                      $event + '%'
                  " (nzBlur)="updateObject()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                      config.desktop_background_active_menu_item
                        .text_decoration_thickness | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.text_decoration_thickness =
                        $event + '%'
                    " (nzOnAfterChange)="updateObject()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
                <ng-container *ngIf="config.desktop_background_active_menu_item.text_decoration_line == 'underline'">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="
                      config.desktop_background_active_menu_item
                        .text_underline_offset | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.text_underline_offset =
                        $event + '%'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
  
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                        config.desktop_background_active_menu_item
                          .text_underline_offset | vhnumber
                      " (ngModelChange)="
                        config.desktop_background_active_menu_item.text_underline_offset =
                          $event + '%'
                      " (nzOnAfterChange)="updateObject()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </ng-container>
                <!-- Màu gạch chân -->
                <div class="config-name">
                  <p class="title-border">{{'mau_gach_chan' | translate}}</p>
                  <div style="width: 50%; max-width: 50%">
                    <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                      config.desktop_background_active_menu_item
                        .text_decoration_color
                    " [style.background]="
                      config.desktop_background_active_menu_item
                        .text_decoration_color
                    " (colorPickerClose)="updateObject()" />
                  </div>
                </div>
                <!-- Khoảng cách giữa các dòng -->
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_giua_cac_dong' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1" [ngModel]="config.desktop_background_active_menu_item.line_height"
                    (ngModelChange)="config.desktop_background_active_menu_item.line_height = $event + ''" (nzBlur)="updateObject()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [ngModel]="config.desktop_background_active_menu_item.line_height"
                    (ngModelChange)="config.desktop_background_active_menu_item.line_height = $event + ''" (nzOnAfterChange)="updateObject()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </ng-container>
            </div>
            <!-- viền khi chọn -->
            <li  nz-submenu nzTitle="{{'cau_hinh_vien_khi_chon' | translate}}">
  
  
              <div class="pl-2">
                <div>
                  <div class="item-border">
                    <p class="m-0 title-border">{{'kieu_vien' | translate}}</p>
                    <div class="field-widget">
                      <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder" nzPopoverTrigger="click">
                        <mat-icon>border_style</mat-icon>
                      </button>
                    </div>
                    <!-- Menu các kiểu viền khác -->
                    <nz-dropdown-menu #menuBorder="nzDropdownMenu">
                      <ul nz-menu>
                        <!-- Kiểu viền solid -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'solid';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{active:config.desktop_background_active_menu_item.border_style == 'solid'}">
                            <div class="icon-field">
                              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                                  fill="#000000" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền double -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'double';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item
                                .border_style == 'double'
                          }">
                            <div class="icon-field">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-border-style" viewBox="0 0 16 16">
                                <path
                                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền dashed -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'dashed';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item
                                .border_style == 'dashed'
                          }">
                            <div class="icon-field">
                              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                                  fill="#000000" />
                              </svg>
                            </div>
                          </button>
                        </li>
                        <!-- Kiểu viền dotted -->
                        <li nz-menu-item>
                          <button (click)="
                            config.desktop_background_active_menu_item.border_style =
                              'dotted';
                            updateClass()
                          " nz-tooltip nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                            [ngClass]="{
                            active:
                              config.desktop_background_active_menu_item
                                .border_style == 'dotted'
                          }">
                            <div class="icon-field">
                              <i class="bi bi-three-dots"></i>
                            </div>
                          </button>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                </div>
                <div class="config-name">
                  <p class="title-border">{{'mau_vien' | translate}}</p>
                  <div style="width: 50%; max-width: 50%">
                    <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true" [cpOKButton]="true" [(colorPicker)]="
                      config.desktop_background_active_menu_item.border_color
                    " [style.background]="
                      config.desktop_background_active_menu_item.border_color
                    " (colorPickerClose)="updateObject()" />
                  </div>
                </div>
  
  
  
  
                <!-- Bo tròn -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_tren' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_top_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_top_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_top_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_top_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_duoi' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_bottom_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_bottom_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_bottom_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_bottom_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_trai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_left_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_left_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_left_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_left_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'kich_thuoc_vien_phai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_right_width
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_right_width =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_right_width
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_right_width =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'bo_tron_vien' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="
                      config.desktop_background_active_menu_item.border_radius
                        | vhnumber
                    " (ngModelChange)="
                      config.desktop_background_active_menu_item.border_radius =
                        $event + 'px'
                    " (nzBlur)="updateObject()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="
                    config.desktop_background_active_menu_item.border_radius
                      | vhnumber
                  " (ngModelChange)="
                    config.desktop_background_active_menu_item.border_radius =
                      $event + 'px'
                  " (nzOnAfterChange)="updateObject()">
                  </nz-slider>
                </div>
              </div>
  
            </li>
          </ul>
        </li>
        <!-- HIỆU ỨNG MENU  CHA-->
        <li (nzOpenChange)="openHandler('menu22')" [(nzOpen)]="openMap.menu22" nz-submenu nzTitle="{{'hieu_ung_menu_cap_0' | translate}}">
          <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [cursorClass]="class['mobilemenu__list--item0']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
            [effectFileUsing]="'menu-vertical'">
          </app-choose-animations-config>
        </li>
        <!-- HIỆU ỨNG MENU  CON-->
        <!-- <li (nzOpenChange)="openHandler('menu30')" [(nzOpen)]="openMap.menu30" nz-submenu nzTitle="{{'hieu_ung_menu_cap_n' | translate}}">
          <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetailChild)="openAnimationDetailChild($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [cursorClass]="class['mobilemenu__list--item1']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
            [isParent]="false" [effectFileUsing]="'menu-vertical'">
          </app-choose-animations-config>
        </li> -->
        <!-- HIỆU ỨNG XUẤT HIỆN MENU CON -->
        <li (nzOpenChange)="openAnimationAppear('mobilemenu'); openHandler('menu15')" nz-submenu nzTitle="{{'hieu_ung_xuat_hien_menu_con' | translate}}" [(nzOpen)]="openMap.menu15">
          <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
            [device]="device" *ngIf="!config['is_prevent_to_close_menu_0']">
          </app-animations-config>
        </li>
      </ul>

      <div>
        <ul nz-menu nzMode="inline">
          <!-- HIỂN THỊ -->
          <li nz-submenu nzTitle="{{'toi_uu_seo' | translate}}" [(nzOpen)]="openMap.menu29" (nzOpenChange)="openHandler('menu29')">
            <!-- Bật role=navigation cho menu chỉ dùng cho header, footer, chatbox -->
            <div class="d-flex justify-content-between align-items-center" nz-tooltip
            [nzTooltipTitle]="'giup_cong_cu_tim_kiem_va_trinh_doc_man_hinh_hieu_ro_vung_dieu_huong' | translate">
              <span>
                {{ 'bat_ho_tro_tiep_can_cho_menu' | translate }}
                <span style="color: red; font-weight: 700"
                > ({{ 'chi_dung_trong_khoi_header_hoac_khoi_footer_hoac_khoi_hop_thoai_chua_bieu_tuong_chat' | translate }})</span>
              </span>
              <nz-switch
                [ngModel]="config.accessibility?.enabled"
                (ngModelChange)="config.accessibility.enabled = $event; updateConfig()"
              ></nz-switch>
            </div>
            <!-- Nếu bật role thì phải có nhãn mô tả -->
            <div *ngIf="config.accessibility?.enabled" class="mt-2" nz-tooltip
            [nzTooltipTitle]="'mo_ta_ngan_menu_vi_du_menu_chinh_hoac_menu_phu_chan_trang' | translate">
              <span>{{ 'nhan_mo_ta_cua_menu' | translate }} <span style="color: red">*</span></span>
              <div>
                <textarea 
                  class="w-100" rows="3" placeholder="{{'nhap_nhan_mo_ta' | translate}}" 
                  [ngModel]="config.accessibility?.['nav_aria_label_' + functionService.selectedLanguageCode] || 'Menu điều hướng chính'"
                  (ngModelChange)="config.accessibility['nav_aria_label_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateConfig()"
                ></textarea>
              </div>
            </div>
          </li>
          <!-- HIỂN THỊ -->
          <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu24" (nzOpenChange)="openHandler('menu24')">
            <div class="button-size">
              <!-- Lựa chọn hiển thị cho các thiết bị -->
              <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
              </app-hide-show-config>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>
  
    <!-- CẤU HÌNH CHI TIẾT -->
    <div class="view-more" *ngIf="isViewAll">
      <!-- Cấu hình chi tiết hiệu ứng -->
      <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3 ||currentViewAll.index == 4 ">
        <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
          [device]="device" [isParent]="currentViewAll.index == 3"></app-animations-config>
      </div>
  
      <!-- Cấu hình chi tiết màu gradient  -->
      <div class="container-gradient" *ngIf="[5, 6, 7, 8].includes(currentViewAll.index)">
        <div class="title-head">
          <p class="text-fill">{{'phoi_mau' | translate}}</p>
          <label nz-checkbox [(ngModel)]="config[fieldConfigGradient[currentViewAll.index]].gradient_check"
            (ngModelChange)="updateBackgroundRgb(currentViewAll.index)"></label>
        </div>
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config[fieldConfigGradient[currentViewAll.index]]['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i, currentViewAll.index)"
            [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config[fieldConfigGradient[currentViewAll.index]].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" 
            [(colorPicker)]="config[fieldConfigGradient[currentViewAll.index]].background"
            type="button" [disabled]="!config[fieldConfigGradient[currentViewAll.index]].gradient_check"
            [style.background]="config[fieldConfigGradient[currentViewAll.index]].background" 
            (colorPickerClose)="addGradient($event, currentViewAll.index)" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, currentViewAll.index)"
          [disabled]="!config[fieldConfigGradient[currentViewAll.index]].gradient_check"
          [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
          [class.active]="config[fieldConfigGradient[currentViewAll.index]].gradient_direction === type.direction">
        </button>
      </div>
    </div>
  </div>